import { render, staticRenderFns } from "./label.vue?vue&type=template&id=5fce8458&scoped=true&"
import script from "./label.vue?vue&type=script&lang=ts&"
export * from "./label.vue?vue&type=script&lang=ts&"
import style0 from "./label.vue?vue&type=style&index=0&id=5fce8458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fce8458",
  null
  
)

export default component.exports